import React from "react";
import "./Spinner.css";

const Spinner = () =>{
    return(
        <div className="flex items-center justify-center w-full">
            <div className="custom-loader">
            </div>
        </div>
    )
};

export default Spinner;